<template>
  <v-container>
    <v-layout column>
      <v-card>
        <v-card-title>
          Contact
        </v-card-title>
        <v-card-text>
          I am currently freelance, looking for a permanent position as a
          software engineer. If you'd like to get in touch about this, or
          anything else, please click below.
        </v-card-text>

        <v-btn href="mailto:samcolson4@gmail.com" class="ma-3 white--text blue"
          >Get in touch</v-btn
        >
        <v-btn href="https://samcolson.substack.com" class="ma-3 white--text blue"
          >Substack</v-btn
        >
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Contact'
};
</script>

<style scoped></style>
